export var FileFormat;
(function (FileFormat) {
    FileFormat["FILE_FORMAT_JSON"] = "JSON";
    FileFormat["FILE_FORMAT_AVRO"] = "AVRO";
})(FileFormat || (FileFormat = {}));
